import React, { useState, useEffect } from 'react';

const VersionDisplay = ({ className = '', style = {} }) => {
  const [version, setVersion] = useState('Loading...');
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        // Try to fetch the version from the public directory
        const response = await fetch('/VERSION');
        if (response.ok) {
          const versionText = await response.text();
          const versionNumber = versionText.trim();
          setVersion(versionNumber);
        } else {
          // Fallback to a default version if file is not accessible
          setVersion('0.0.0');
        }
      } catch (err) {
        console.warn('Could not fetch version from file, using fallback:', err);
        // Fallback version
        setVersion('0.0.0');
        setError('Version file not accessible');
      }
    };

    fetchVersion();
  }, []);

  return (
    <span 
      className={`version-display ${className}`} 
      style={style}
      title={error ? `Error: ${error}` : `Version: ${version}`}
    >
      v{version}
    </span>
  );
};

export default VersionDisplay;
